import * as React from 'react';

import styles from './ImageAsDocumentMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessage } from '../ChatMessage';

interface IImageAsDocumentMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  image: React.ReactNode;
  imageInfo: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  replyQuote: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const ImageAsDocumentMessageLayout = React.forwardRef<HTMLDivElement, IImageAsDocumentMessageLayoutProps>(
  function ImageAsDocumentMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      image,
      imageInfo,
      messageMeta,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage
        errorSign={errorSign}
        errorText={errorText}
        dataName="ImageAsDocumentMessageLayout"
        className={styles['container']}
      >
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['quote']}>{replyQuote}</div>
          <div className={styles['image']}>{image}</div>
          <div className={styles['image-info']}>
            {imageInfo}
            <div className={styles['meta']}>{messageMeta}</div>
          </div>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
